import React from "react";
import Container from "../components/Layouts/Container";
import Landing from "../components/Landing/Landing";

const LandingPage = () => {
  return (
    <Container>
      <Landing />
    </Container>
  );
};

export default LandingPage;
